<template>
    <b-modal size="lg" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="prefix + title">

        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row>

                        <lg-form-date invalidFeedback="A data deve ser informada!"
                            description="Informe o período da data emprestimo" v-model="form.data"
                            label="Data Empréstimo:*" cols="12" sm="6" />

                        <lg-form-date invalidFeedback="A data deve ser informada!"
                            description="Informe o período da data" v-model="form.previsaoDevolucao"
                            label="Data Prev. Devolução:" cols="12" sm="6" />


                        <lg-form-input invalidFeedback="Responsável deve ser informado!" description=""
                            v-model="form.respCriacao" label="Responsável:*" cols="12" sm="6" disabled />

                        <b-col cols="6">
                            <lg-finder-page-pessoa id="finderUsuarioEmprestimo" label="Responsável pela guarda:"
                                @onselect="handlePessoaSelect" v-model="form.pessoa"
                                invalidFeedback="Informe um responsável!" :prefix="prefix + title + ' > '"
                                :title="'Responsáveis'">
                            </lg-finder-page-pessoa>
                        </b-col>

                        <b-col cols="6">
                            <lg-finder-page-tipo-documento :prefix="[prefix + title]" id="finderTipoDocumento"
                                label="Tipo de Documento:" @onselect="handlerTipoDocumento" v-model="form.tipoDocumento"
                                invalidFeedback="Informe um responsável!">
                            </lg-finder-page-tipo-documento>
                        </b-col>

                        <lg-form-input invalidFeedback="Número do documento deve ser informado!" description=""
                            v-model="form.numDocEmprestimo" label="Nº Documento:" cols="12" sm="6" />

                        <lg-form-const-select label="Tipo de Empréstimo:" v-model="tipoEmprestimo"
                            :options="optionsFilterEmprestimo" cols="12" sm="6" />


                        <b-col cols="6">
                            <lg-finder-page-status-guia :prefix="prefix + title" id="finderStatusGuia"
                                label="Status Guia de Saída:" @onselect="selectStatusGuia" v-model="form.statusGuia"
                                invalidFeedback="Informe o Status da Guia!">
                            </lg-finder-page-status-guia>
                        </b-col>


                        <lg-form-input v-if="tipoEmprestimo == 1" invalidFeedback="Origem deve ser informada!"
                            description="" v-model="form.departamentoOrigem.nome" label="Origem:*" cols="12" sm="6"
                            disabled />

                        <lg-finder-page-empresa v-if="tipoEmprestimo == 2" :prefix="[prefix + title]"
                            id="finderEmpresaOrigemForm" label="Origem:*" @onselect="selectEmpresaOrigem"
                            v-model="form.empresaOrigem" invalidFeedback="Informe o Destino!">
                        </lg-finder-page-empresa>



                        <b-col cols="6">
                            <lg-finder-page-unidade-administrativa v-if="tipoEmprestimo == 1"
                                :prefix="prefix + title + ' > '" id="finderUnidadeDestino" label="Destino:*"
                                @onselect="selectDestino" v-model="form.departamentoDestino"
                                invalidFeedback="Informe o Destino!">
                            </lg-finder-page-unidade-administrativa>

                            <lg-finder-page-empresa v-if="tipoEmprestimo == 2" :prefix="[prefix + title]"
                                id="finderEmpresaDestinoForm" label="Destino:*" @onselect="selectEmpresaDestino"
                                v-model="form.empresaDestino" invalidFeedback="Informe o Destino!">
                            </lg-finder-page-empresa>

                        </b-col>


                        <lg-form-input invalidFeedback="Motivo deve ser informado!" description="" v-model="form.motivo"
                            label="Motivo:*" cols="12" sm="12" />

                        <lg-form-input invalidFeedback="Observação deve ser informada!" description=""
                            v-model="form.observacao" label="Observacao:" cols="12" sm="12" />

                        <b-col cols="6" class="text-left">
                            <span>Item Bem Permanente:*</span>
                        </b-col>


                        <b-col cols="6" class="text-right">
                            <b-button id="adicionarIBPEmprestimo" style="height: 20px;" class="ml-3 mr-2 my-2" size="sm"
                                pill variant="primary" @click="showModalItens">
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div> <b-tooltip target="adicionarIBPEmprestimo" title="Adicionar novo..."></b-tooltip>
                            </b-button>
                        </b-col>

                    </b-form-row>
                </b-card>
                <b-card bg-variant="light">
                    <b-table responsive class="mt-2" small :items="this.form.itens" :fields="this.tableFields"
                        :hover="true" show-empty>
                        <template #empty>
                            <p>Nenhum registro encontrado</p>
                        </template>

                        <template v-slot:cell(dataDevolucao)="row">

                            <lg-form-date invalidFeedback="A data de deve ser informada!" description=" "
                                v-model="row.item.dataDevolucao" class="mt-3" />


                        </template>


                        <template v-slot:cell(action)="row">
                            <b-button :id="row.index + 'excluirItem'" class=" my-2" size="sm" pill variant="primary"
                                @click="removeItem(row.item)">
                                <b-icon icon="trash-fill" />
                                <b-tooltip :target="row.index + 'excluirItem'" title="Remover..."></b-tooltip>

                            </b-button>
                        </template>


                    </b-table>
                </b-card>
            </b-card-body>
        </b-card>


        <b-form-row>

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
                <b-button id="salvarTipoDocumento" class=" my-2" size="sm" pill variant="success" @click="save">
                    <b-icon icon="check-circle" />
                    <b-tooltip target="salvarTipoDocumento" title="Salvar"></b-tooltip>

                </b-button>

                <b-button id="cancelarTipoDocumento" class=" my-2 ml-2" size="sm" pill variant="danger"
                    @click="cancelar">
                    <b-icon icon="x-circle" />
                    <b-tooltip target="cancelarTipoDocumento" title="Cancelar"></b-tooltip>

                </b-button>
            </b-col>
            <b-col cols="3"></b-col>

        </b-form-row>

        <ModalPageItemBemPermanente :prefix="prefix + title" v-if="showItens" @close="fecharModalPageIBP"
            @onselect="addItens">
        </ModalPageItemBemPermanente>

    </b-modal>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import moment from 'moment'
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import LgFinderPageTipoDocumento from '@/components/Finders/LgFinderPageTipoDocumento.vue'
import LgFinderPageStatusGuia from '@/components/Finders/LgFinderPageStatusGuia.vue'
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import ModalPageItemBemPermanente from '@/core/components/Modals/ModalPageItemBemPermanente.vue'
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"

export default {
    components: {
        LgFormInput,
        LgFormDate,
        LgFinderPagePessoa,
        LgFinderPageTipoDocumento,
        LgFinderPageStatusGuia,
        LgFinderPageUnidadeAdministrativa,
        ModalPageItemBemPermanente,
        LgFinderPageEmpresa,
        LgFormConstSelect

    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    data() {
        return {
            optionsFilterEmprestimo: [
                { value: 1, text: "Interno" },
                { value: 2, text: "Externo" },
            ],
            tipoEmprestimo: 1,
            title: 'Cadastro',
            showItens: false,
            showModal: true,
            form: {
                empresaOrigem: {},
                itens: [],
                pessoa: {},
                data: "",
                dataPrevDevolucao: "",
                numDocEmprestimo: "",
                departamentoOrigem: {},
                departamentoDestino: {},
                statusGuia: {},
                motivo: "",
                observacao: "",
                previsaoDevolucao: "",
                empresaDestino: {},

            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/emprestimo`);

        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form = data;

        } else {

            const brand = JSON.parse(localStorage.getItem('context'));
            this.form.respCriacao = brand.usuario.nome;
            this.form.departamentoOrigem = brand.departamento

            new ResourceService(`/api/empresa`).get("getEmpresaSenadoFederal").then(response => {
                this.form.empresaOrigem = response.data;

            });

        }
    },


    props: {

        id: Number,
        prefix: {
            type: String,
            default: "",
        }
    },

    computed: {
        tableFields() {
            return [

                { key: "item.numTombamento", label: "Tombamento" },

                { key: "item.numero", label: "Número" },

                { key: "item.descricaoResumida", label: "Produto" },
                {
                    key: "dataDevolucao", label: " Data Devolução", formatter: (value) => value ? moment(value).format('DD/MM/YYYY') : "",
                },

                { key: "action", label: " ", tdClass: "w-1" },
            ];
        },
    },
    methods: {

        selectEmpresaOrigem(empresaDestino) {
            this.form.empresaOrigem = empresaDestino;
        },


        selectEmpresaDestino(empresaDestino) {
            this.form.empresaDestino = empresaDestino;
        },
        async removeItem(item) {
            this.form.itens.splice(
                this.form.itens.indexOf(item),
                1
            );
        },

        async save() {

            if ((this.tipoEmprestimo == 2 ? (!this.form.empresaDestino.id) : false) ||
                (this.tipoEmprestimo == 1 ? (!this.form.departamentoDestino.id) : false) ||
                (!this.form.data || this.form.data == '') ||
                (!this.form.itens || this.form.itens.length == 0) ||
                (!this.form.motivo || this.form.motivo == '')) {
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos de cadastro!",
                });
                return;

            }


            var payload = {
                id: this.form.id,
                data: this.form.data,
                previsaoDevolucao: this.form.previsaoDevolucao,
                respCriacao: this.form.respCriacao,
                pessoa: this.form.pessoa && this.form.pessoa.id ? this.form.pessoa : null,
                tipoDocumento: this.form.tipoDocumento && this.form.tipoDocumento.id ? this.form.tipoDocumento : null,
                numDocEmprestimo: this.form.numDocEmprestimo,
                tipoEmprestimo: this.form.tipoEmprestimo,
                statusGuia: this.form.statusGuia && this.form.statusGuia.id ? this.form.statusGuia : null,
                motivo: this.form.motivo,
                departamentoDestino: this.form.departamentoDestino,
                departamentoOrigem: this.form.departamentoOrigem,
                observacao: this.form.observacao,
                itens: this.form.itens.map(item => ({ dataDevolucao: item.dataDevolucao, item: { id: item.item.id } })),
            }

            try {
                await this.$saveResource(payload, "", false);
                this.cancelar();
            } catch (e) {
                this.$notify({
                    type: "danger",
                    message: e.response.data,
                });
            }


        },

        showModalItens() {
            this.showItens = true;
        },
        fecharModalPageIBP() {
            this.showItens = false;
        },
        addItens(itemNovo) {

            this.showItens = false;

            const found = this.form.itens.find(
                item => item.id === itemNovo.id
            );

            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Item Bem Permanente já vinculado!",
                });
                return;
            }


            this.form.itens.push({ item: itemNovo, dataDevolucao: "" });
        },
        selectDestino(unidade) {

            this.form.departamentoDestino = unidade;
        },
        handlerTipoDocumento(tipo) {
            this.form.tipoDocumento = tipo;
        },
        handlePessoaSelect(item) {
            this.form.pessoa = item;
        },

        cancelar() {
            this.$emit("close");
        },

        selectStatusGuia(status) {
            this.form.statusGuia = status;
        },

        async removerResource(item) {
            this.$removeResource(item);
        },

    },
};
</script>